import Recat from 'react'
import Temp from './components/temp';
function App() {
  return (
    <Temp/>
  );
}

export default App;
